import { all, fork, takeEvery } from 'redux-saga/effects';

import { CurrentStakeType } from '../../types';
import type { SagaIterator } from '@redux-saga/types';

import { StakeType } from 'app/lib/staking/constants';

import { PROCESS_STAKES, ProcessStakes } from '../../actions/submission';
import processExpress from './express';
import processSingles from './singles';
import processSystem from './system';
import watchStakeProcessComplete from './watchStakeProcessComplete';
import watchSubmissionEnd from './watchSubmissionEnd';

// ---

function getSubmitSagaByStakeType(stakeType: CurrentStakeType) {
  if (stakeType.has(StakeType.SINGLE)) {
    return processSingles;
  }
  else if (stakeType.has(StakeType.EXPRESS)) {
    return processExpress;
  }
  else if (stakeType.has(StakeType.SYSTEM)) {
    return processSystem;
  }

  throw new Error(`unrecognized stake type [${stakeType}]`);
}

export default function* submission(): SagaIterator {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  yield takeEvery(PROCESS_STAKES, (
    function* ({ payload: { stakeType, entries, betsInfo } }: { payload: ProcessStakes['payload'] }) {
      yield all([
        fork(getSubmitSagaByStakeType(stakeType), entries),
        fork(watchStakeProcessComplete, entries.size, betsInfo),
        fork(watchSubmissionEnd, entries.size),
      ]);
    }
  ));
}
